import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";
import { AI_NOTE, TERMS_URL } from "../lib/plans";

const PricingTrustNote = () => (
    <section
        data-testid="pricing-trust-note"
        className="relative border-t border-white/10 bg-ink py-12"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.p
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="max-w-3xl font-mono text-[13px] leading-relaxed tracking-[0.18em] text-cad"
            >
                {AI_NOTE}{" "}
                <a
                    href={TERMS_URL}
                    data-testid="pricing-terms-link"
                    className="text-mist underline decoration-white/30 underline-offset-4 transition-colors duration-300 hover:text-accent"
                >
                    Terms link
                </a>
                .
            </motion.p>
        </div>
    </section>
);

export default PricingTrustNote;
